/* eslint-disable */
import ReportPerformanceList from './report-performance.list';

export default {
  // TODO: Temporarily use auto-render reports
  // list: ReportPerformanceList,
};
